import { useCallback } from 'react'

import { Checkbox } from 'core-components/library/checkbox'
import { urlValidation } from 'core-components/library/richTextEditor/helpers/urlHelper'
import { ValidateInput } from 'core-components/library/validation'

import { ICoommonLinkSettigsProps } from './interface/ICommonLinkSettingsPtops'

export const CommonLinkSettingsContent = (props: ICoommonLinkSettigsProps) => {
  const checkUrl = useCallback(
    (url: string): Promise<string> => {
      if (!url && !props.required) {
        return new Promise((res) => res(''))
      }

      return urlValidation(url)
    },
    [props.required]
  )

  return (
    <>
      <ValidateInput
        label={'Link'}
        value={props.url || ''}
        onChange={(value) => props.onChange('url', value)}
        margin={'md'}
        checkFn={checkUrl}
      />
      <Checkbox
        disabled={!props.url}
        checked={Boolean(props.openInNewTab)}
        label="Open in new tab"
        margin="md"
        onChange={(value) => props.onChange('openInNewTab', value)}
      />
    </>
  )
}
